export function formatDateBorn(input: string) {
  let cleaned = input?.replace(/\D/g, "");
  if (cleaned?.length > 8) {
    cleaned = cleaned?.substr(0, 8);
  }
  let formatted = cleaned?.replace(/(\d{2})(\d{2})(\d{4})/, "$1/$2/$3");
  return formatted;
}

export function formatCPF(input: string) {
  let cleaned = input?.replace(/\D/g, "");
  if (cleaned?.length > 11) {
    cleaned = cleaned?.substr(0, 11);
  }
  let formatted = cleaned?.replace(
    /(\d{3})(\d{3})(\d{3})(\d{2})/,
    "$1.$2.$3-$4"
  );
  return formatted;
}
